import { WarningAmber } from "@mui/icons-material";
import { Chip } from "@mui/material";
import { Colors } from "Components/Layout/Themes/Colors";
import { Resources, useResource } from "Translations/Resources";

export const NotRecommendedBadge = () => {
  const { t } = useResource();

  return (
    <Chip
      icon={<WarningAmber />}
      label={t(Resources.BankRating.NotRecommended.Badge)}
      size="small"
      sx={{
        backgroundColor: Colors.DarkOrange,
        color: "white",
        fontWeight: 500,
        fontSize: 10,
        textTransform: "uppercase",
        "& .MuiChip-icon": {
          color: Colors.White,
          fontSize: 10,
          ml: 2,
        },
      }}
    />
  );
};
